import {isNil} from 'ramda';

import {Language} from '@dms/api/sales';

import {isSupportedLanguage} from './toLanguage';

/**
 * Maps a tenant Locale (e.g. `cs-CZ`, `nl-BE`) to the 2-letter generation Language.
 * Returns null when the locale's language part is not a supported generation language,
 * so callers can fall back (e.g. to the generator config language).
 */
export function localeToLanguage(locale: string | null | undefined): Language | null {
  if (isNil(locale)) {
    return null;
  }

  const [language] = locale.split('-');

  return isSupportedLanguage(language) ? language : null;
}
